// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`LegalText test Match con el snapshot 1`] = `""`;
